/* Huggler cart milestone bar — confetti + fill animation.
   The bar markup/states are rendered by Liquid (snippet cart-progress-bar-custom) and re-rendered
   by the theme on every cart change. This script only:
     1. animates the progress fill (grow from 0) on each render / drawer open
     2. fires Huggler-coloured confetti inside the drawer when a NEW reward tier unlocks
   Seeds silently on load so an existing cart doesn't blast confetti when the drawer first opens. */
(function () {
  if (window.__hmbInit) return;
  window.__hmbInit = true;
  var FIRED = 'hmbFired';

  function getFired() { try { return JSON.parse(sessionStorage.getItem(FIRED) || '[]'); } catch (e) { return []; } }
  function setFired(a) { try { sessionStorage.setItem(FIRED, JSON.stringify(a)); } catch (e) {} }

  function drawerEl() { return document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('#CartDrawer'); }
  function drawerVisible() { var d = drawerEl(); if (!d) return false; var r = d.getBoundingClientRect(); return r.width > 0 && r.height > 0; }

  function animateFill(bar) {
    var fill = bar.querySelector('.hmb__linefill'); if (!fill) return;
    var target = fill.getAttribute('data-fill'); if (target == null) return;
    fill.style.transition = 'none';
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.transition = ''; fill.style.width = target + '%'; });
    });
  }

  function burst() {
    var d = drawerEl(); if (!d || typeof window.confetti !== 'function') return;
    var r = d.getBoundingClientRect(); if (r.width <= 0) return;
    var origin = { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + Math.min(r.height * 0.32, 220)) / window.innerHeight };
    window.confetti({
      particleCount: 110, spread: 72, startVelocity: 40, gravity: 0.9, scalar: 0.95, ticks: 160,
      origin: origin, disableForReducedMotion: true,
      colors: ['#00AFA9', '#FCD94D', '#4DD19E', '#FC9E59', '#ED828A', '#FFFFFF']
    });
    var c = document.querySelector('canvas'); // confetti canvas -> above the drawer
    if (c && c.style) { c.style.position = 'fixed'; c.style.top = '0'; c.style.left = '0'; c.style.width = '100%'; c.style.height = '100%'; c.style.zIndex = '2147483647'; c.style.pointerEvents = 'none'; }
  }

  function reachedIdx(bar) {
    return Array.prototype.map.call(bar.querySelectorAll('.hmb__step'), function (n, i) { return n.classList.contains('is-reached') ? i : -1; }).filter(function (i) { return i >= 0; });
  }

  function update(allowConfetti) {
    var bar = document.querySelector('.hmb'); if (!bar) return;
    animateFill(bar);
    var reached = reachedIdx(bar);
    var fired = getFired().filter(function (i) { return reached.indexOf(i) !== -1; }); // reset tiers no longer reached
    var newUnlock = false;
    reached.forEach(function (i) { if (fired.indexOf(i) === -1) { fired.push(i); newUnlock = true; } });
    if (newUnlock && allowConfetti && drawerVisible()) burst();
    setFired(fired);
  }

  function init() {
    update(false); // seed silently
    var cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      new MutationObserver(function (muts) {
        if (muts.some(function (m) { return m.type === 'childList'; })) setTimeout(function () { update(true); }, 140);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      new MutationObserver(function () {
        if (cd.classList.contains('active') || cd.classList.contains('animate')) {
          setTimeout(function () { var b = document.querySelector('.hmb'); if (b) animateFill(b); }, 60);
        }
      }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
